/*
 * bsub-zipify.js
 *
 * Zipify-only presentation tweak for the Bold Subscriptions widget.
 *
 * On Zipify Landing Section pages, the wording that normally appears in
 * `bsub-widget__plans-container` ("Delivery Frequency / Monthly / $38.37 / delivery")
 * is moved up into the "Subscribe and save" tile inside `bsub-widget__groups-container`,
 * and the original plans container is hidden.
 *
 * Design notes:
 *
 * - Loaded from `snippets/bsub-widget.liquid` so it ships with the widget on every page,
 *   but it is a no-op unless the `--is-zipify-page` CSS custom property is set, which
 *   `assets/bsub.scss.css` declares on `:root`. That stylesheet only loads on Zipify
 *   pages, so the property is the marker. We do NOT depend on the layout file or any
 *   Zipify-managed Liquid for detection — Zipify updates can revert those.
 *
 * - This script must NOT touch `bsub.js` — that file can be overwritten by a Zipify
 *   update. Everything here works against the rendered DOM and Bold's public globals.
 *
 * - We CLONE three elements out of the active plan (legend, plan name `.bsub-widget__text`,
 *   and the `[data-bsub-per-delivery-price]` span), then append them to the matching
 *   group tile. We do NOT move them — moving would put a radio input inside the group
 *   tile and risk breaking selectors used elsewhere in the widget.
 *
 * - The cloned price span has its `data-bsub-per-delivery-price` attribute STRIPPED so
 *   bsub.js's `_renderPrices` (which writes prices via that attribute) only sees the
 *   original target. A `MutationObserver` on the original mirrors any updated price
 *   into the clone, so the in-tile price tracks variant changes.
 */
document.addEventListener('DOMContentLoaded', function () {
  var marker = getComputedStyle(document.documentElement)
    .getPropertyValue('--is-zipify-page').trim();
  if (marker !== '1') return;

  // Bold's bsub.js initializes on DOMContentLoaded too — wait until it has run so
  // that [data-bsub-per-delivery-price] spans actually contain a formatted price.
  var tries = 0;
  (function waitForBold() {
    if (window.BOLD && window.BOLD.BsubWidget) return relocate();
    if (tries++ > 50) return; // ~5s ceiling; if Bold never loads we just bail
    setTimeout(waitForBold, 100);
  })();

  function relocate() {
    document.querySelectorAll('[data-bsub-widget]').forEach(function (widget) {
      widget.querySelectorAll('[data-bsub-selling-plans-container]').forEach(function (plansContainer) {
        var groupId = plansContainer.dataset.bsubSellingPlanGroupId;
        var groupTile = widget.querySelector(
          '[data-bsub-selling-plan-group][data-bsub-selling-plan-group-id="' + groupId + '"]'
        );
        if (!groupTile) return;

        var legend = plansContainer.querySelector('legend');

        // Prefer the actively-checked plan; otherwise fall back to the first plan.
        var checkedInput = plansContainer.querySelector('[data-bsub-selling-plan-input]:checked');
        var activePlan = (checkedInput && checkedInput.closest('[data-bsub-selling-plan]'))
          || plansContainer.querySelector('[data-bsub-selling-plan]');
        if (!activePlan) return;

        var planNameEl = activePlan.querySelector('.bsub-widget__plan-header .bsub-widget__text');
        var priceEl    = activePlan.querySelector('[data-bsub-per-delivery-price]');

        var summary = document.createElement('div');
        summary.className = 'bsub-widget__group-plan-summary';

        if (legend)     summary.appendChild(legend.cloneNode(true));
        if (planNameEl) summary.appendChild(planNameEl.cloneNode(true));

        var clonedPrice = null;
        if (priceEl) {
          clonedPrice = priceEl.cloneNode(true);
          // Strip the data attribute so bsub.js's _renderPrices doesn't target the clone.
          clonedPrice.removeAttribute('data-bsub-per-delivery-price');
          summary.appendChild(clonedPrice);
        }

        // Trailing " / delivery" matches the wording from the original plans container.
        summary.appendChild(document.createTextNode(' / delivery'));

        groupTile.appendChild(summary);
        plansContainer.style.display = 'none';

        // Mirror bsub.js's price re-renders (e.g. on variant change) into the clone.
        if (priceEl && clonedPrice) {
          new MutationObserver(function () {
            clonedPrice.innerHTML = priceEl.innerHTML;
          }).observe(priceEl, { childList: true, characterData: true, subtree: true });
        }
      });
    });
  }
});
